import timg1 from '../images/team/team_member_image_1.webp'
import timg2 from '../images/team/team_member_image_2.webp'
import timg3 from '../images/team/team_member_image_3.webp'
import timg4 from '../images/team/team_member_image_4.webp'
import timg5 from '../images/team/team_member_image_5.webp'


const Teams = [
   {
      Id: '1',
      tImg: timg1,
      name: 'Kingsford Ofori',
      slug: 'kingsford-ofori',
      title: 'Managing Director',
      bio: 'Over 12 years of experience in Information Technology, Electrical and Electronic Engineering. Expert in ID card personalization systems, Access Control Systems, and Fire detection systems.'
   },
   {
      Id: '4',
      tImg: timg4,
      name: 'Maxwel Chiri',
      slug: 'maxwel-chiri',
      title: 'Project Manager',
      bio: '7+ years of experience in project management and systems integration. Holds a BSc in Commerce and a Postgraduate Certificate in Anti-Money Laundering and Financial Crime.'
   },
   {
      Id: '5',
      tImg: timg5,
      name: 'Frank Akornor Sowah-Kpobi',
      slug: 'frank-sowah-kpobi',
      title: 'Elec/Electronic Support',
      bio: '12+ years of experience in Electrical and Electronic Engineering. Specializes in diagnosing and repairing industrial power supply units, UPS systems, and various electronic equipment.'
   },
   {
      Id: '6',
      tImg: timg1,
      name: 'Joseph Sackey',
      slug: 'joseph-sackey',
      title: 'Mechanical Engineer',
      bio: 'Brings in 11+ years of technical and engineering experience in welding, fabrications, and pipe fittings. Expert in mechanical design and project management.'
   },
   {
      Id: '7',
      tImg: timg2,
      name: 'Erete Otu',
      slug: 'erete-otu',
      title: 'Director of Operations',
      bio: '8+ years of experience in Health, Safety and Environmental (HSE) products marketing in the petroleum industry. MBA holder with expertise in Fire Fighting and Foam hardware systems.'
   },
   {
      Id: '8',
      tImg: timg3,
      name: 'Hilda Amoah',
      slug: 'hilda-amoah',
      title: 'Administrative Secretary',
      bio: '11 years of experience in Information Technology and administrative functions. Holds a BSc in Information Technology and trained in Human Resource management.'
   },
   {
      Id: '9',
      tImg: timg4,
      name: 'Berenger Aguissi',
      slug: 'berenger-aguissi',
      title: 'HP Consulting Engineer',
      bio: '13+ years of experience in IT with specialization in HP Data Center enterprise solutions. HP Master Accredited Systems Engineer with expertise in Storage Area Network (SAN) Architecture.'
   },
   {
      Id: '10',
      tImg: timg5,
      name: 'John Amonoo',
      slug: 'john-amonoo',
      title: 'Enterprise & Power Manager',
      bio: '12+ years of field experience in computer environment. Graduate of Takoradi Polytechnic with certifications in Business Systems and HP Enterprise Solutions.'
   }
];

export default Teams;